<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>
